import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestCreateGifMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RequestCreateGifMutation = { __typename?: 'RootMutationType', requestCreateGif?: { __typename?: 'VideoUploadResult', videoUpload?: { __typename?: 'VideoUpload', id: string, gifWithIconUrl?: string | null, currentGifRequest?: { __typename?: 'VideoProcessingRequest', id: string, status?: Types.VideoProcessingStatus | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };

export type VideoUploadOnRequestCreateGifFragment = { __typename?: 'VideoUpload', id: string, gifWithIconUrl?: string | null, currentGifRequest?: { __typename?: 'VideoProcessingRequest', id: string, status?: Types.VideoProcessingStatus | null } | null };

export const VideoUploadOnRequestCreateGifFragmentDoc = gql`
    fragment VideoUploadOnRequestCreateGif on VideoUpload {
  id
  gifWithIconUrl
  currentGifRequest {
    id
    status
  }
}
    `;
export const RequestCreateGifDocument = gql`
    mutation requestCreateGif($id: ID!) {
  requestCreateGif(id: $id) {
    videoUpload {
      ...VideoUploadOnRequestCreateGif
    }
    userErrors {
      field
      message
    }
  }
}
    ${VideoUploadOnRequestCreateGifFragmentDoc}`;
export type RequestCreateGifMutationFn = Apollo.MutationFunction<RequestCreateGifMutation, RequestCreateGifMutationVariables>;

/**
 * __useRequestCreateGifMutation__
 *
 * To run a mutation, you first call `useRequestCreateGifMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCreateGifMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCreateGifMutation, { data, loading, error }] = useRequestCreateGifMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestCreateGifMutation(baseOptions?: Apollo.MutationHookOptions<RequestCreateGifMutation, RequestCreateGifMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCreateGifMutation, RequestCreateGifMutationVariables>(RequestCreateGifDocument, options);
      }
export type RequestCreateGifMutationHookResult = ReturnType<typeof useRequestCreateGifMutation>;
export type RequestCreateGifMutationResult = Apollo.MutationResult<RequestCreateGifMutation>;
export type RequestCreateGifMutationOptions = Apollo.BaseMutationOptions<RequestCreateGifMutation, RequestCreateGifMutationVariables>;